import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  logOut,
  refreshSession,
  setIsRefreshingToken,
} from "../features/authSlice";

import { RootState } from "../../store";
import { HttpResponse } from "../../enums";
import { generateQuerywithTakeSkipFromArgs } from "../../utils";
import { Mutex } from "async-mutex"; // Import the mutex from async-mutex

import { showToast } from "../../components/utils/toasts/SharedToast";
 
const mutex = new Mutex();

/**
 * base query
 */
const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_SERVER_URL,

  prepareHeaders: (headers, { getState }) => {
    const accessToken = (getState() as RootState).auth.accessToken;
    if (accessToken) {
      headers.set("authorization", `Bearer ${accessToken}`);
      // headers.set("Content-Type", "application/json"); // Set the Content-Type header
    }
    return headers;
  },

  // responseHandler: (response: any) => {
  //   console.log("response handler", response.json());
  //   return response;
  // },
});

//basequery with reauth or logout if it failds
const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
  const { refreshToken, accessToken, isRefreshingToken } = api.getState().auth;
  //if isRefreshingToken is true wait one second and half then execute next lines
  if (isRefreshingToken)
    await new Promise((resolve) => setTimeout(() => resolve, 1500));
  const startTime = Date.now();
  let result = await baseQuery(args, api, extraOptions);
  const endTime = Date.now();

  const duration = (endTime - startTime) / 1000; // time in seconds

  const error: any = result?.error;

  // handle
  if (result?.error?.status === HttpResponse.UNAUTHORIZED) {
    if (!mutex.isLocked()) {
      const release = await mutex.acquire();
      try {
        api.dispatch(setIsRefreshingToken(true));
        const refreshResult = await baseQuery(
          {
            url: `/auth/refreshToken`,
            method: "POST",
            headers: {
              Accept: "application/json", // Specify that the response should be in JSON format
            },
            body: { refreshToken },
          },
          api,
          extraOptions
        );
        if (refreshResult?.data) {
          const auth = api.getState().auth;
          // store the new token
          await api.dispatch(
            refreshSession({ ...refreshResult.data } as {
              accessToken: string;
              refreshToken: string;
            })
          );
          // retry the original query with new access token
          if (args?.url != "/auth/refreshToken")
            result = await baseQuery(args, api, extraOptions);
        } else if (refreshResult?.error?.status === HttpResponse.UNAUTHORIZED) {
          api.dispatch(logOut());
        }
        api.dispatch(setIsRefreshingToken(false));
      } finally {
        release();
      }
    } else {
      await mutex.waitForUnlock();
      result = await baseQuery(args, api, extraOptions);
    }
  }
  if (error?.status === HttpResponse.BAD_REQUEST) {
    console.log("bad request error", error.status, error.data);
    let message = "";
    const message_1 =
      "Login ou mot de passe invalide, en cas de persistance du problème, veuillez contacter le support";
    const message_2 = "Veuillez choisir juste votre centre";
    const message_3 = "Veuillez choisir votre centre et votre box";
    const message_4 =
      "Votre accès ne nécessite pas de centre ou de box, veuillez les supprimer";

    if (
      error?.data?.message.includes("you must choose your center") &&
      error?.data?.message.endsWith("center")
    )
      message = message_2;
    if (
      error?.data?.message.includes("you must choose your center") &&
      error?.data?.message.endsWith("station")
    )
      message = message_3;
    if (error?.data?.message.includes("you must not choose center or station"))
      message = message_4;

    if (message.length)
      showToast({
        id: 15,
        message,
        type: "error",
      });
  }
  if (result?.data) {
    const isUpload = args.method && args.method.toUpperCase() === "POST";

    // Calculate data size in bytes
    const dataSizeBytes = new Blob([JSON.stringify(result.data)]).size;

    // Convert duration to seconds
    const durationSeconds = duration / 1000; // Assuming duration is in milliseconds

    // Calculate speed in bytes per second (Bps)
    const speedBps = dataSizeBytes / durationSeconds;

    // Convert speed to kilobytes per second (kBps) and megabytes per second (MBps)
    const speedKBps = speedBps / 1024;
    const speedMBps = speedKBps / 1024;

    // Determine appropriate unit and value
    // let speed, unit;


    // if (speedMBps >= 1) {
    //   speed = speedMBps.toFixed(2);
    //   unit = "MBps"; // Megabytes per second
    // } else if (speedKBps >= 1) {
    //   speed = speedKBps.toFixed(2);
    //   unit = "kBps"; // Kilobytes per second
    // } else {
    //   speed = speedBps.toFixed(2);
    //   unit = "Bps"; // Bytes per second
    // }

    // api.dispatch(
    //   setConnectionSpeed({
    //     speed: Number(speed),
    //     unit: unit,
    //     isConnected: true,
    //     isUpload,
    //   })
    // );
  }
  return result;
};

// baseQuery with general params
const baseQueryWithParams = async (args: any, api: any, extraOptions: any) => {
  const [skip, take, newQuery] = generateQuerywithTakeSkipFromArgs(args);
  if (api.type === "query")
    return baseQueryWithReauth(newQuery, api, extraOptions);
  return baseQueryWithReauth(args, api, extraOptions);
};

export const api = createApi({
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({}),
});
